webpackJsonp([176948426173393],{

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _page = __webpack_require__(5);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _contentblock = __webpack_require__(9);
	
	var _contentblock2 = _interopRequireDefault(_contentblock);
	
	var _sidebar = __webpack_require__(18);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _infobox = __webpack_require__(23);
	
	var _infobox2 = _interopRequireDefault(_infobox);
	
	var _dexa = __webpack_require__(161);
	
	var _dexa2 = _interopRequireDefault(_dexa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DexaPage = function DexaPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_page2.default, { headline: 'DEXA', image: _dexa2.default }),
	    _react2.default.createElement(
	      'section',
	      { className: 'container-custom split' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-custom' },
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Vorbereitungen in der Ordination:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Informieren Sie uns \xFCber eventuelle ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'H\xFCftprothesen, Wirbels\xE4ulen-Versteifungen'
	              ),
	              ' o.\xE4.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Geben Sie Ihre pers\xF6nliche Daten (',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Gr\xF6\xDFe und Gewicht'
	              ),
	              ') an.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Die ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Anamnese'
	              ),
	              ' erfolgt durch das R\xF6ntgenpersonal.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Entkleiden Sie sich ab der H\xFCfte bis auf die Unterw\xE4sche.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Die Untersuchung erfolgt im Liegen.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Befundsbesprechung:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Die Patient/innen erhalten den ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Befund'
	              ),
	              ' direkt nach der Untersuchung oder per Post.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'aside',
	        { className: 'sidebar' },
	        _react2.default.createElement(_sidebar2.default, null),
	        _react2.default.createElement(_infobox2.default, { name: 'dexa' })
	      )
	    )
	  );
	};
	
	exports.default = DexaPage;
	module.exports = exports['default'];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dexa.dc4bdf51.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-leistungen-dexa-js-baea4d9783cbf8cb7381.js